// src/components/Loader.js
// ──────────────────────────────────────────────────────────────────────────
// First-load splash. Shows the logo + a reassuring message while the page and
// its assets load — most useful on slow connections. Controlled via `visible`.
// ──────────────────────────────────────────────────────────────────────────

import React from 'react';
import styled, { keyframes } from 'styled-components';
import theme from '../theme/theme';
import logo from '../assets/star.png';

const pulse = keyframes`0%,100%{transform:scale(1);opacity:0.9}50%{transform:scale(1.06);opacity:1}`;
const slide = keyframes`0%{transform:translateX(-100%)}100%{transform:translateX(100%)}`;

const Wrap = styled.div`
  position: fixed; inset: 0; z-index: 4000; background: ${theme.color.blueDeep};
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1.4rem;
  transition: opacity 0.6s ease, visibility 0.6s ease;
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  visibility: ${(p) => (p.$visible ? 'visible' : 'hidden')};
  img { height: 96px; width: 96px; object-fit: cover; border-radius: 50%;
        border: 1px solid rgba(255,255,255,0.18); animation: ${pulse} 1.8s ${theme.ease} infinite; }
  .msg { color: rgba(255,255,255,0.9); font-family: ${theme.font.body}; font-size: 1rem; letter-spacing: 0.01em; }
  .bar { width: 180px; height: 3px; border-radius: 3px; background: rgba(255,255,255,0.15); overflow: hidden; position: relative; }
  .bar::after { content: ''; position: absolute; inset: 0; width: 50%; background: ${theme.color.lemon}; animation: ${slide} 1.2s ${theme.ease} infinite; }
`;

export default function Loader({ visible }) {
  return (
    <Wrap $visible={visible} aria-hidden={!visible}>
      <img src={logo} alt="CGA Mbala Training Institute" />
      <p className="msg">Sit tight — we’re setting up your pages…</p>
      <div className="bar" />
    </Wrap>
  );
}
